import { render, staticRenderFns } from "./ColorPreview.vue?vue&type=template&id=b801849e&scoped=true"
import script from "./ColorPreview.vue?vue&type=script&lang=js"
export * from "./ColorPreview.vue?vue&type=script&lang=js"
import style0 from "./ColorPreview.vue?vue&type=style&index=0&id=b801849e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b801849e",
  null
  
)

export default component.exports